module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAMCAYAAABSgIzaAAAAAXNSR0IArs4c6QAAASVJREFUKBWdUDGKg1AUnGzWwiskYG/jDYxgb2luYGMnomm8gLEUPISQKrVCoo1XsBFrtbIQTLG778N3E9zdYgf0wbwZZ3ybjy/gH3jjnrZtYVkWkiSB4zic/nW+883lcoEsy7BtG3EcM3ocR/R9zyVsSpKE7XaLxbjb7UDmqqpA6TSzLENd1yAxoSxLBEEAXdex4f/oeR6OxyMT/PVK0xRRFH0n7vd73O935HmOx+MBwzAW//V6hSAILIl0hCWRq263G4qiYELf93E+n9mHVFWFpmlchuWqnKElieZ5hmmaP5pIuzISeTgcMAwDFEVB13UvSbQnrKoSGYYhSxJFEdM0sdqn04lWC1aJ3ER1XddltelYxD/jxUjLpmlYNX4ImvQQ/2z+BJzxhThNN2KqAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/exterior-mesa.png
// module id = 503
// module chunks = 0